import $ from 'jquery';
import Join from './components/join';
import Newsletter from './components/newsletter';
import TopBar from './components/top-bar';

class App {
    constructor() {
        if (!window.pawscoutLoaded) {
            this.init();
            window.pawscoutLoaded = true;
        }
    }

    init() {
        this.$body = $('body');

        new TopBar($('.header-wrap'));

        this.initMenu();
        this.initNewsletter()

        $('.join').each((i, el) => {
            new Join($(el));
        });

        this.$body.on('click', '.share-url', e => {
            e.currentTarget.select();
        });

        this.$body.on('click', '.show-password', e => {
            let $field = $(e.currentTarget).closest('.form-field'),
                $input = $field.find('input');

            $field.toggleClass('is-shown');
            if ($field.hasClass('is-shown')) {
                $input.attr('type', 'text');
            } else {
                $input.attr('type', 'password');
            }
        });

        this.$body.on('input', '.form input', e => {
            let $input = $(e.currentTarget),
                $form = $input.closest('.form'),
                $submit = $form.find('[type="submit"]');

            if ($form.find('[required]:placeholder-shown, .error').length) {
                $submit.attr('disabled', 'disabled');
            } else {
                $submit.removeAttr('disabled');
            }

            this.updateCount($input);
        });
    }

    initMenu() {
        $('.js-menu').on('click', e => {
            e.preventDefault();
            this.$body.toggleClass('menu-in');
        });
    }

    updateCount($field) {
        let length = $field.val().length;

        $field.closest('.form-field').find('.count').text(length);
    }

    static loginWithFacebook(redirect_url) {
        // user logged in via FB, redirect
        FB.getLoginStatus(function(response) {
            if (response.status === 'connected' && response.authResponse && response.authResponse.accessToken) {
                let f = document.createElement('form'),
                    i = document.createElement('input');

                f.action = redirect_url;
                f.method = 'POST';

                i.type = 'hidden';
                i.name = 'accessToken';
                i.value = response.authResponse.accessToken;
                f.appendChild(i);

                document.body.appendChild(f);
                f.submit();
            }
        });
    }

    async initNewsletter () {
        const newsletterForm = document.querySelector('.js-newsletter-form')

        if (!newsletterForm) {
            return
        }

        new Newsletter(newsletterForm)
    }
}

window.App = App;

document.addEventListener('DOMContentLoaded', () => new App());
